import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Breadcrumbs, useTheme } from "@mui/material";
import { Link } from "react-router-dom";

import { ExpandableCopyText } from "@/shared/components";

interface DeviceHeaderProps {
  deviceId: string;
}

export const DeviceHeader: React.FC<DeviceHeaderProps> = ({ deviceId }) => {
  const theme = useTheme();

  const breadcrumbs = [
    <Link key="list" to="/devices">
      Devices
    </Link>,
    <ExpandableCopyText key="deviceId" text={deviceId} trimLength={15} />,
  ];

  return (
    <>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
        sx={{
          fontSize: "0.95rem",
          fontWeight: "500",
          borderBottom: "unset",
          "& a": {
            color: theme.palette.text.secondary,
            textDecoration: "none",
          },
          "& a:hover": {
            textDecoration: "underline",
          },
        }}
      >
        {breadcrumbs}
      </Breadcrumbs>
    </>
  );
};
